<template>
  <lxm-row :name="name" @click="clicked">
    <img class="lxm-org-item__right-arrow" src="../../images/main/contact/panel-right-arrow.png" />
  </lxm-row>
</template>

<style lang="stylus" scoped>
  @import '../../styles/variables.styl'
  .lxm-org-item__right-arrow
    width: siz(7)
    height: siz(12)
</style>

<script>
  import LxmRow from './LxmRow.vue'
  import * as mTypes from '../../../store/mutation-types'
  export default {
    components: {
      LxmRow
    },
    props: {
      id: String,
      name: String
    },
    methods: {
      clicked () {
        this.$store.commit(mTypes.TRANSITION_SET_BACK)
        this.$router.push({
          path: '/main/contact/org',
          query: {
            orgId: this.id
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmOrgItem.vue?f8d3cc3a